import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import LanguageDetector from 'i18next-browser-languagedetector'
import * as _ from 'lodash'

import type { APIUser } from '../api'
import de from './messages/de.json'
import en_ae from './messages/en-AE.json'
import en_my from './messages/en-MY.json'
import en_qa from './messages/en-QA.json'
import en_qc from './messages/en-QC.json'
import en_sa from './messages/en-SA.json'
import en_us from './messages/en-us.json'
import en from './messages/en.json'
import es_mx from './messages/es-mx.json'
import es from './messages/es.json'
import fr_ma from './messages/fr-MA.json'
import fr_qc from './messages/fr-QC.json'
import fr from './messages/fr.json'
import it from './messages/it.json'
import ja from './messages/ja.json'
import ko from './messages/ko.json'
import lt from './messages/lt.json'
import nl from './messages/nl.json'
import pt_br from './messages/pt-br.json'
import pt from './messages/pt.json'
import ru from './messages/ru.json'
import th from './messages/th.json'
import tr from './messages/tr.json'
import vi from './messages/vi.json'
import zh_cn from './messages/zh-cn.json'
import zh_hk from './messages/zh-hk.json'
import zh_tw from './messages/zh-tw.json'

export const deleteExtension = (src: string, ext: string): string => {
  return src.substring(0, src.length - ext.length)
}

const resources = {
  de: { translation: de },
  en: { translation: en },
  en_ae: { translation: en_ae },
  en_my: { translation: en_my },
  en_qa: { translation: en_qa },
  en_qc: { translation: en_qc },
  en_us: { translation: en_us },
  en_sa: { translation: en_sa },
  es: { translation: es },
  es_mx: { translation: es_mx },
  fr: { translation: fr },
  fr_qc: { translation: fr_qc },
  fr_ma: { translation: fr_ma },
  it: { translation: it },
  ja: { translation: ja },
  ko: { translation: ko },
  lt: { translation: lt },
  nl: { translation: nl },
  pt: { translation: pt },
  pt_br: { translation: pt_br },
  ru: { translation: ru },
  th: { translation: th },
  tr: { translation: tr },
  vi: { translation: vi },
  zh_cn: { translation: zh_cn },
  zh_hk: { translation: zh_hk },
  zh_tw: { translation: zh_tw },
}

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    // detection: options,
    detection: { order: ['path', 'navigator'] },
    debug: true,
    resources,
    compatibilityJSON: 'v3',
    load: 'currentOnly', // languageOnly : load only fr when locale is fr-CA
    react: {
      useSuspense: false,
    },
    //lng: 'en',
    fallbackLng: ['en', 'fr'],
    interpolation: {
      escapeValue: false,
    },
    cleanCode: true,
  })

export default i18n

export const tWithParams = (str: string, params: { [key: string]: string }) => {
  let text = str
  _.forEach(params, (value: string, key: string) => {
    text = text.replaceAll(`{{${key}}}`, value)
  })
  return text
}

/*
const keyWithPrefix = `${cleanPrefix}.${key}`
    if (i18n.exists(keyWithPrefix)) {
      return t(keyWithPrefix, options)
    }
    if (!i18n.exists(key)) {
      //To force a missing key log of the keyWithPrefix if even the key doest not exists
      t(keyWithPrefix, options)
    }
    return t(key, options)
*/

export const graphicalCharterLink = async (user?: APIUser): Promise<string | undefined> => {
  try {
    const prefix = _.isUndefined(user) ? '' : _.get(user, 'poiType', '').toLowerCase()
    const key = 'graphical-charter-html-content'
    const keyWithPrefix = `${prefix.trim()}.${key}`

    let filename = ''
    if (i18n.exists(keyWithPrefix)) {
      filename = i18n.t(keyWithPrefix)
    } else if (!i18n.exists(key)) {
      //To force a missing key log of the keyWithPrefix if even the key doest not exists
      filename = i18n.t(keyWithPrefix)
    } else {
      filename = i18n.t(key)
    }
    const tmp = deleteExtension(filename, '.pdf')
    if (!_.isEmpty(tmp)) {
      const pdf = await import(`./contents/${tmp}.pdf?url`)
      return pdf.default
    }
  } catch (error) {
    console.error('graphicalCharterLink ', error)
  }
  return undefined
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const tHtml = async (page: string, params?: any, user?: APIUser) => {
  let p = params
  if (!p || !(typeof p === 'object')) {
    p = {}
  }
  if (!_.isEmpty(page)) {
    const __html = await import(`./contents/${deleteExtension(page, '.html')}.html?raw`)
    const __guidelines = await graphicalCharterLink(user)
    return tWithParams(__html.default, { ...p, guidelines: __guidelines })
  }
  return ''
}
